import { kebabToCamel } from './utils.mjs'

const angularModule = angular.module('vvuejs.angularPlaceHolder', [])

// Get angular references at angular init
let $angularCompile;
let $angularRootScope;

angularModule.run(function ($compile, $rootScope) {

    $angularCompile = $compile
    $angularRootScope = $rootScope

})

export default {
    props: ['component', 'handler', 'parentScope'],
    template: '<div class="vueplaceholder"></div>',
    mounted() {

        let parentScope = this.parentScope || $angularRootScope

        this.$scope = parentScope.$new(true)

        this.$scope.component = this.component
        this.$scope.handler = this.handler
        
        this.element = document.createElement('vodalys-form-place-holder');
        this.element.setAttribute('component', 'component')
        this.element.setAttribute('handler', 'handler')

        // Passage de function du style ( @on-v-myFunction="maFunction({arg: $event})" )
        // C'est un bricolage moche pour la conversion en vuejs de vcreator18
        let filteredListeners = Object.keys(this.$listeners).filter((k) => {return k.startsWith('on-')})
        for(let i in filteredListeners)
        {
            let listenerName = filteredListeners[i];
            
            let callbackString = this.$listeners[listenerName].fns.toString();

            let callbackResult = callbackString.match(/(function\(\$event\){return\s)(\w+)\((.*)\)}/);

            let callbackName = callbackResult[2];
            let args = callbackResult[3];

            let argsResult = args.match(/{(\w+)(\s*):(\s*)(.*)}/);
            var argName = argsResult[1];

            this.element.setAttribute(listenerName.slice(3), callbackName+'('+ argName +')');

            let callback = this.$listeners[listenerName];

            this.$scope[callbackName] = function(arg)
            {
                callback(arg);
            }
        }

        // Passage de paramtre ( :param="myParam" )
        for(let attr in this.$attrs)
        {
            this.element.setAttribute(attr, kebabToCamel(attr));
            this.$scope[kebabToCamel(attr)] = this.$attrs[attr];

            this.$watch('$attrs.'+kebabToCamel(attr), function(value)
            {
                this.$scope[kebabToCamel(attr)] = value
                setTimeout(() => this.$scope.$digest())
            })
        }

        this.element = $angularCompile(this.element)(this.$scope)[0]

        // this.$el.style.display = 'contents'
        this.$el.appendChild(this.element)

    },
    watch : {
        component (value) {
            this.$scope.component = value
            setTimeout(() => this.$scope.$digest())
        },
        handler(value) {
            this.$scope.handler = value
            setTimeout(() => this.$scope.$digest())
        }
    },
    beforeDestroy() {
        this.$scope.$destroy()
    }
}
